import { css } from 'styled-components';
import {
  getSpacing, SpacingName, getTypography, TypographyName, ThemedFunctor, ellipsis,
} from '@doveit/lego';

export const base: ThemedFunctor = ({
  theme,
  $active,
}) => css`
  border: 1px solid ${theme.palettes.neutrals.light};
  ${getSpacing.padding(theme, SpacingName.SMALLER)};
  border-radius: 6px;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
  background: none;
  width: 100%;
  outline: 0;

  ${$active && `
    border-color: ${theme.palettes.brand.primary};
    background-color: ${theme.palettes.brand.primaryLight};
  `}
`;

export const icon: ThemedFunctor = ({
  theme,
}) => css`
  color: ${theme.palettes.brand.primary};
`;

export const label: ThemedFunctor = ({
  theme,
}) => css`
  ${ellipsis()}
  ${getTypography(theme, TypographyName.SMALL)}
  padding-top: .5em;
`;
